import axios from "axios";
import constant from "../_config/constant";
import { authHeader, logout } from "../_helpers";

const api = axios.create({ baseURL: constant.apiUrl });

export const getChatToken = async () => {
  try {
    const response = await api.get(`/chat/token`, {
      headers: authHeader(),
    });

    return response;
  } catch (error) {
    if (error.response && error.response.status === 403) {
      logout();
      window.location.reload();
      return;
    }
    throw error;
  }
};

export const updateUserResource = async (id, data) => {
  try {
    const response = await api.post(
      `/chat/update`,
      {
        identity: id,
        user: data,
      },
      { headers: authHeader() }
    );
    return response;
  } catch (error) {}
};

// Server-side find-or-create: guarantees both participants are on the conversation,
// avoiding the client SDK's create-vs-Conflict race (see Message/index.js).
export const ensureChatChannel = async ({ propertyId, reservationId }) => {
  const response = await api.post(
    `/chat/ensure-channel`,
    { propertyId, reservationId },
    { headers: authHeader() }
  );
  return response;
};
